<template>
  <div>
    <div class="row m-b-lg m-t-lg wrapper">
        <div v-if="account.name" class="col-md-12">
          <div class="row">
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td><strong>Name</strong></td>
                  <td>
                    <a-edit-txt
                      type="editable"
                      :text="account.name"
                      @input="updateProperty($event, 'name')"
                      close-on-save="true"
                    ></a-edit-txt>
                  </td>
                </tr>
                <tr>
                  <td><strong>URL</strong></td>
                  <td>
                    <a-edit-txt
                      type="editable"
                      :text="account.url"
                      @input="updateProperty($event, 'url')"
                      close-on-save="true"
                    ></a-edit-txt>
                  </td>
                </tr>
                <tr>
                  <td><strong>Description</strong></td>
                  <td>
                    <a-edit-txt
                      type="editable"
                      :text="account.description"
                      @input="updateProperty($event, 'description')"
                      close-on-save="true"
                    ></a-edit-txt>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td><strong>Departments</strong></td>
                  <td>
                    <v-select multiple label="label" index="index" :options="departments" v-model="account.departments" @input="updateProperty($event, 'departments')">
                    </v-select>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-4">
                <button class="btn btn-danger btn-sm pull-right" @click="deleteAccount()"><i class="fa fa-trash m-r-xs"></i> Delete</button>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { FormValidation } from '../../../../mixins/helperMixin'

export default {
  data () {
    return {
      departments: []
    }
  },
  props: {
    account: { required: true }
  },
  mixins: [FormValidation],
  mounted () {
    this.loadDepartments()
  },
  methods: {
    async loadDepartments () {
      let r = await axios.get('/v2/data-structures/departments')
      this.departments = r.data.values
    },
    async updateProperty (val, key) {
      if (key === 'url' && !this.isUrl(val)) {
        this.$toastr.warning('Invalid URL format')
        return
      }
      let data = {}
      data[key] = val
      try {
        await axios.patch(`/v2/service-accounts/${this.account.id}`, data)
        this.$toastr.success('Account updated successfully!')
      } catch (error) {
        this.$toastr.error('Update Failed', error)
      }
    },
    async deleteAccount () {
      if (confirm(`Are you sure you want to delete ${this.account.name}?`)) {
        try {
          await axios.delete(`/v2/service-accounts/${this.account.id}`)
          this.$toastr.success('You will be redirected to credentials page', 'Account deleted!')
          await this.$router.push('/service-accounts')
        } catch (error) {
          this.$toastr.error('Unable to Delete', error)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/ServiceAccounts/SingleView/Header.vue